import { render } from "./HeroCreator.vue?vue&type=template&id=79feed54"
import script from "./HeroCreator.vue?vue&type=script&lang=js"
export * from "./HeroCreator.vue?vue&type=script&lang=js"

import "./HeroCreator.vue?vue&type=style&index=0&id=79feed54&lang=css"
script.render = render

export default script